// extracted by mini-css-extract-plugin
export default {"pocSalesforceLinkIcon":"PocSalesforceLinkIcon_pocSalesforceLinkIcon__5paqr"};